export default __webpack_public_path__ + "media/images/footer/amex-ad2b100900129417c074d2fc46480b3d.svg";